export default __webpack_public_path__ + "static/media/BrainBreak cards22.19329353.png";